// import { IS_IFRAME } from "./model";

export const TOGGLE_COOKIES = "TOGGLE_COOKIES";
export const CHANGE_COOKIES = "CHANGE_COOKIES";
export const CHANGE_ANIMATION = "CHANGE_ANIMATION";

export function changeCookies(val) {
  return { type: CHANGE_COOKIES, val };
}
export function changeAnimation(val) {
  return { type: CHANGE_ANIMATION, val };
}
export const toggleCookies = () => ({
  type: TOGGLE_COOKIES
});